<template>
  <div>
    <Header/>
    <Parser/>
    <JsonResponse/>
    <CodeSnippet />
  </div>
</template>

<script>
    import Header from "./Header";
    import Parser from "./Parser";
    import JsonResponse from "./JsonResponse";
    import CodeSnippet from "./CodeSnippet";
    export default {
      name: "Main",
      components: { JsonResponse, Parser, Header, CodeSnippet },
      created() {
        this.$store.commit("SET_PAGE_TYPE", "parser");
        this.$store.commit("SET_PAGE_FOOTER_BACKGROUND_COLOR", "linear-gradient(104.96deg, #F29300 0.72%, #FFC000 94.5%)");
        // console.log("Background Color", this.$store.state.pageFooterBackgroundColor);
      }
    }
</script>

<style scoped>

</style>
